import Vue from 'vue'

const el = document.querySelector('#notification')
if (el !== null) {
  const vm = new Vue({
    delimiters: ['${', '}'],
    data: {
      show: false,
      notificationActive: true,
      className: 'notification-active'
    },
    methods: {
      hideNotification () {
        this.show = false
        localStorage.notificationActive = true
        this.className = 'hidden'
      },
      showNotification () {
        this.show = true
        localStorage.notificationActive = true
        this.className = 'notification-active'
      }
    },
    mounted () {
      if (localStorage.notificationActive) {
        this.show = false
        this.className = 'hidden'
      } else {
        this.show = true
        this.className = 'notification-active'
        localStorage.notificationActive = true
      }
    },
    watch: {
      current () {
        if (localStorage.notificationActive) {
          this.show = localStorage.notificationActive
          this.className = 'hidden'
        } else {
          localStorage.notificationActive = true
          this.show = localStorage.notificationActive
          this.className = 'notification-active'
        }
      }
    }
  })
  vm.$mount(el)
}
